

const InputSearchReports = ({ pullback, defaultValue = '' }) => {

    return (
        <>
            <div className='fh'>
                <div className='searchTypeRow mobOrange' >
                    <div className='searchType'>
                        <input type='search' placeholder='جستجوی ...' value={defaultValue} onChange={(e) => pullback(e.target.value)} />
                    </div>
                </div>
            </div>
        </>
    )
}

export default InputSearchReports;